import { getApiUrl, getCurrentLanguageId, openComponentInPopup } from "./common";
import HttpClient from "./http-client";
import { initFirstVisitorPopup } from "./main";
import { PopupWidth } from "./popup";
import { isFirstVisitorPopupSuppressed } from "./first-visitor-suppression";


export default class FirstVisitorInitializer{
    popupConfig: FirstVisitorPopupConfig;

    constructor() {
        // Persistent: this browser got a coupon or said "not interested" (explicit actions only — a logged-in
        // visitor is hidden server-side per request, and a shared computer must not inherit their choice).
        if (isFirstVisitorPopupSuppressed()) {
            return;
        }

        // Per tab session: offer it at most once per session.
        const hide = sessionStorage.getItem('first-visitor-popup-disable');
        if (hide == 'true') {
            return;
        }
        sessionStorage.setItem('first-visitor-popup-disable', 'true');
        this.init();
    }

    private async init() {
        this.popupConfig = await this.getPopupConfig();
        if (!this.popupConfig)
            return;

        if (!this.popupConfig.enabled)
            return;

        setTimeout(async () => {
            await openComponentInPopup('FirstVisitorPopup', null, { id: 'first-visitor-popup', width: this.popupConfig.windowSize });
            await initFirstVisitorPopup();
        }, this.popupConfig.delayMs);
    }

    private async getPopupConfig(): Promise<FirstVisitorPopupConfig> {
        const client = new HttpClient();
        const url = `${getApiUrl()}/coupon/get-first-visitor-config`
        const response = await client.fetch(url, {
            headers: {
                'Current-Language-Id': getCurrentLanguageId()
            }
        });

        if (!response.ok) return;
        return await response.json() as FirstVisitorPopupConfig;
    }
}

interface FirstVisitorPopupConfig {
    enabled: boolean,
    windowSize: PopupWidth;
    delayMs: number;
}
